/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Policy_Sharing_DescriptionInputs */



/**
* | output |
* | --- |
* | "When set to members, a member may share an agent they created with teams or the whole organization and keep editing it. Only administrators designate approve..." |
*
* @param {Agent_Policy_Sharing_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_sharing_description = /** @type {((inputs?: Agent_Policy_Sharing_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Sharing_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bei „Alle Mitglieder“ darf ein Mitglied einen selbst erstellten Agenten mit Teams oder der ganzen Organisation teilen und ihn weiter bearbeiten. Freigebende Personen für geteilte Agenten legen nur Administratoren fest.")
	return /** @type {LocalizedString} */ ("When set to members, a member may share an agent they created with teams or the whole organization and keep editing it. Only administrators designate approvers on shared agents.")
});